import { useNavigate } from "react-router-dom";
import { Button } from "react-scroll";
import { CalendarSvg, PremiumServiceSvg } from "../../components/Assets";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import TopPageBack from "../../components/TopPageBack";
import { CEO_TYPES } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import PremiumServiceCards from "./PremiumServiceCards";
import { useState, useEffect } from "react";
import ShopApi from "../../apis/shop.api";
import formatDateToKorean from "../../utils/formatDateToKorean";
import shortDateString2Date from "../../utils/shortDateString2Date";
import beautifyDate from "../../utils/beautifyDate";
import { store } from "../../store";
import CeoApi from "../../apis/ceo.api";
import { useSelector } from "react-redux";
import moment from "moment";

const PremiumService = function () {
  const navigate = useNavigate();
  const { ceoInfo } = useAuth();
  const [isFreeTrial, setIsFreeTrial] = useState(false);
  const [serviceStartDate, setServiceStartDate] = useState(false);
  const [serviceEndDate, setServiceEndDate] = useState(false);
  const [premiumAmountWithVat, setPremiumAmountWithVat] = useState(0);
  const [isPremiumDeleted, setIsPremiumDeleted] = useState(false);
  const mCeo = useSelector((state) => state.Ceo);
  const ceoType = mCeo?.ceoType;

  const isPremiumUser =
    ceoInfo?.ceo_type === CEO_TYPES.PREMIUM || ceoType === CEO_TYPES.PREMIUM;
  const getShopServiceInfo = async () => {
    if (ceoInfo?.shop_idx) {
      const res = await ShopApi.getShopServiceInfo(ceoInfo?.shop_idx);
      if (res.data.data) {
        const { isFreeTrial, serviceStartDate, serviceEndDate } = res.data.data;
        setServiceStartDate(serviceStartDate?.trim());
        setServiceEndDate(serviceEndDate?.trim());
        let isServiceEnd = moment(serviceEndDate).isBefore(moment());
        setIsFreeTrial(isFreeTrial?.trim() === "Y" && !isServiceEnd);
      }
    }
  };
  const getPremiumAmountWithVat = async () => {
    if (ceoInfo?.shop_idx) {
      const res = await ShopApi.getPremiumAmountWithVat({
        shopIdx: ceoInfo?.shop_idx,
        currentDate: new Date(),
      });
      if (res.data.data) {
        setPremiumAmountWithVat(res.data.data);
      }
    }
  };
  const getCeoStatus = async () => {
    if (ceoInfo?.ceo_idx) {
      const response = await CeoApi.getDeleteStatus(ceoInfo?.ceo_idx);
      if (response.data.data) {
        setIsPremiumDeleted(response.data.data["canceledPremium"]);
      }
    }
  };

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const checkWidth = () => {
    setIsSmallScreen(window.innerWidth < 650);
  };

  useEffect(() => {
    checkWidth();
    getCeoStatus();
    getShopServiceInfo();
    getPremiumAmountWithVat();
    // Add event listener to handle window resize
    window.addEventListener("resize", checkWidth);
  }, []);
  const onBack = () => {
    if (window.history?.length && window.history.length > 1) {
      window.history.replaceState(null, null, "/");
      navigate(-1);
    } else {
      navigate("/more", { replace: true });
    }
  };
  return (
    <div>
      <TopPageBack onBack={onBack}>
        <b>프리미엄 서비스 관리</b>
      </TopPageBack>
      {isPremiumUser ? (
        <div className="mx-5 pb-16">
          {isFreeTrial && (
            <>
              <div className="h-4"></div>
              <div className=" rounded-2xl bg-appblue py-4 px-5 text-white flex items-center gap-6">
                <div>
                  <img src={CalendarSvg} alt="calendar" />
                </div>
                <div>
                  <div className="text-lg font-bold">
                    {" "}
                    {formatDateToKorean(shortDateString2Date(serviceEndDate)) ??
                      " "}
                  </div>
                  <div className="text-lg font-bold mb-2">
                    무료 체험이 종료돼요.{" "}
                  </div>
                  <div className="text-xs">
                    무료 기간이 만료되면 자동 유료로 전환돼요.{" "}
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="review-card2 py-4 mt-6 flex flex-col">
            <div className="flex flex-col gap-2">
              <div className="text-lg font-bold mb-1">
                {isFreeTrial ? "무료 체험 정보" : "이용 정보"}
              </div>
              <div className="bg-light-aqua2 p-4 rounded-lg ">
                <div className="mb-6">
                  <div className="text-15 text-darkblue">
                    {isFreeTrial ? "무료 체험 신청일" : "프리미엄 신청일"}
                  </div>
                  <div className="text-base font-bold text-darkblue">
                    {beautifyDate(serviceStartDate)}
                  </div>
                </div>
                <div>
                  <div className="text-base text-darkblue">
                    {isFreeTrial ? "무료 체험 기간" : "납부 금액"}
                  </div>
                  {(function () {
                    if (isFreeTrial) {
                      return (
                        <div className="text-base font-bold text-darkblue">
                          {beautifyDate(serviceStartDate) +
                            "~" +
                            beautifyDate(serviceEndDate)}
                        </div>
                      );
                    }

                    return (
                      <div className="text-base font-bold text-darkblue">
                        {premiumAmountWithVat
                          .toLocaleString()
                          .replaceAll(".", ",")}
                        원<span className="font-normal">(부가세 포함)</span>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>

          <div className="pt-3">
            <div className=" mb-5  text-base font-bold text-darkblue">
              프리미엄 전용 기능
            </div>
            <PremiumServiceCards />
          </div>

          {/* Temporarily hide this function bc client request */}
          {/* <Button
            className="w-full text-center delete-account-btn"
            onClick={() => {
              if (isPremiumDeleted) {
                navigate(ROUTE_PATHS.CancelPremiumDeleteRequest);
              }
              else
                navigate(ROUTE_PATHS.DeleteReason, {
                  state: {
                    type: 'delete-premium'
                    // type: 'delete-account'
                  }
                })
            }}
          >
            {isPremiumDeleted ? '프리미엄 서비스 해지 취소' : '프리미엄 서비스 해지하기'}
          </Button> */}
        </div>
      ) : (
        <div
          style={{
            height: "calc(85vh - 100px)",
          }}
          className="flex flex-col w-screen h-screen items-center text-center justify-center px-[30px] "
        >
          <div className="mb-6">
            <img src={PremiumServiceSvg} />
          </div>
          <div className="font-bold mb-2">
            프리미엄에서만 이용하실 수 있어요.
          </div>
          {isSmallScreen ? (
            <div className="mb-7 text-blue">
              <div className="">
                사장님 리뷰를 대신 관리하고 분석해 드려요. 고객과의
              </div>
              <div>
                소통은 저희에게 맡기시고 장사에만 집중하세요.
              </div>
            </div>
          ) : (
            <div className="mb-7 text-blue">
              사장님 리뷰를 대신 관리하고 분석해 드려요. 고객과의
              소통은 저희에게 맡기시고 장사에만 집중하세요.
            </div>
          )}
          {/* <div className="text-[#3451d7]">
            첫 가입 시 한 달 무료체험을 할 수 있어요!
          </div> */}
          <div className="w-full items-center flex justify-center">
            <SolidBlueBtn
              className="mt-6"
              style={{ padding: "8px 20px" }}
              // onClick={() => navigate(ROUTE_PATHS.EditCardManage)}
              onClick={() => navigate(ROUTE_PATHS.PremiumIntro)}
            >
              프리미엄 가입하기
            </SolidBlueBtn>
          </div>
        </div>
      )}
    </div>
  );
};
export default PremiumService;
